import React from 'react';
import moment from 'moment';
import { Field, submit } from 'redux-form';

import { TextField as TextFieldUI } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import EventIcon from '@material-ui/icons/Event';
import { KeyboardDatePicker } from '@material-ui/pickers';

import { DATE_FORMAT, TIME_FORMAT } from 'constants/config';

import { DatePickerModal } from './DatePickerModal';

const DateField = (props) => {
  const {
    meta,
    input: { value, onChange, onFocus, onBlur },
    disabled,
    InputProps,
    dateType = 'datetime',
    helperText = '',
    dateformat,
    submitOnChange,
    label = '',
    ...others
  } = props;

  const dispatch = meta.dispatch;
  const form = meta.form;
  const issetError = meta.touched && meta.error;

  let df = DATE_FORMAT;
  if (dateType === 'datetime') {
    df = `${DATE_FORMAT}, ${TIME_FORMAT}`;
  } else if (dateType === 'time') {
    df = TIME_FORMAT;
  }
  if (dateformat) df = dateformat;

  const formatValue = (val) => {
    if (!val) return null;
    if (dateType === 'time') return moment(val, [moment.ISO_8601, 'HH:mm:ss']);
    return moment(val);
  };

  const pickerValue = formatValue(value || null);

  const createResult = (date) => {
    if (!date) return null;
    if (dateType === 'time') return date.second(0).format('HH:mm:ss');
    return date.second(0).toISOString();
  };

  const [open, setOpen] = React.useState(false);
  const [pickerError, setPickerError] = React.useState(null);
  const [clearKey, setClearKey] = React.useState(0);

  const _onChange = (date) => {
    onChange(createResult(date));
    setTimeout(() => {
      if (submitOnChange) dispatch(submit(form));
    }, 0);
  };

  // date: KeyboardDatePicker — ручной ввод + стандартный MUI календарь с выбором года
  if (dateType === 'date') {
    const handleKeyboardChange = (date, textValue) => {
      if (date === null || !textValue) {
        onChange(null);
        setPickerError(null);
        setClearKey((k) => k + 1);
        if (submitOnChange) setTimeout(() => dispatch(submit(form)), 0);
        return;
      }
      if (date.isValid()) {
        onChange(date.endOf('day').toISOString());
        setPickerError(null);
        if (submitOnChange) setTimeout(() => dispatch(submit(form)), 0);
      } else if (!textValue.includes('_')) {
        setPickerError('Неверный формат даты');
      }
    };

    return (
      <KeyboardDatePicker
        key={clearKey}
        fullWidth
        autoOk
        autoComplete="off"
        disabled={disabled}
        label={label}
        format={df}
        value={pickerValue}
        onChange={handleKeyboardChange}
        onFocus={() => onFocus(value)}
        onBlur={() => onBlur(value)}
        error={!!issetError || !!pickerError}
        helperText={issetError || pickerError || helperText || undefined}
        InputProps={InputProps}
        clearable
        clearLabel="Сбросить"
        cancelLabel="Отмена"
        okLabel="Готово"
        invalidDateMessage=""
        keyboardIcon={<EventIcon fontSize="small" />}
        KeyboardButtonProps={{ style: { padding: 2 } }}
        InputAdornmentProps={{ style: { marginLeft: 0 } }}
        {...others}
      />
    );
  }

  // datetime / time: текстовый инпут + наша модалка (MUI Calendar + кастомный Clock)
  const inputText = pickerValue ? pickerValue.format(df) : '';

  return (
    <FormControl fullWidth error={!!issetError}>
      <div onClick={() => !disabled && setOpen(true)}>
        <TextFieldUI
          fullWidth
          autoComplete="off"
          error={!!issetError}
          disabled={disabled}
          label={label}
          value={inputText}
          onFocus={() => onFocus(value)}
          onBlur={() => onBlur(value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="calendar"
                  tabIndex={-1}
                  size="small"
                  style={{ padding: 4 }}>
                  <EventIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
            ...InputProps
          }}
        />
      </div>
      <DatePickerModal
        isOpen={open}
        handleClose={() => setOpen(false)}
        onChange={(date) => {
          _onChange(date);
          setOpen(false);
        }}
        dateType={dateType}
        clearable
        value={pickerValue}
      />
      {(issetError || helperText) && (
        <FormHelperText>{issetError || helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

const FormDateField = (props) => {
  const { source, ...rest } = props;
  return <Field component={DateField} name={source} {...rest} />;
};

export default FormDateField;
